import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  OnDestroy,
  effect,
} from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { WorkflowLogsComponent } from "../workflow-logs/workflow-logs.component";
import {
  EMPTY,
  Observable,
  Subject,
  debounceTime,
  distinctUntilChanged,
  switchMap,
} from "rxjs";
import { CommonModule, DatePipe } from "@angular/common";
import { WorkflowLineItemsComponent } from "../workflow-line-items/workflow-line-items.component";
import saveAs from "file-saver";
import { ProjectTaskListComponent } from "../project-task-list/project-task-list.component";
import { ConfirmationService } from "primeng/api";
import { JniToastrService } from "../../../core/services/jni-toastr.service";
import { UserManagementService } from "../../../core/services/user-management.service";
import { GetChatMessageListDto } from "../../../core/models/common/GetChatMessageListDto";
import { SendChatMessageRequestDto } from "../../../core/models/common/SendChatMessageRequestDto";
import { UserTagDto } from "../../../core/models/common/userTagDto";
import { GenericResponseDto } from "../../../core/models/generic-response.dto";
import { GetAllBuyersRequestDto } from "../../../core/models/orders/getAllBuyersRequestDto";
import { GetAllBuyersResponseDto } from "../../../core/models/orders/getAllBuyersResponseDto";
import { AddWorkflowProposalsDto } from "../../../core/models/project-workflow/addWorkflowProposalsDto";
import { DeleteProjectWorkflowLinesDto } from "../../../core/models/project-workflow/deleteProjectWorkflowLinesDto";
import { ProductionWorkflowDetails } from "../../../core/models/project-workflow/productionWorkflowDetails";
import { ProductionWorkflowLineDto } from "../../../core/models/project-workflow/productionWorkflowLineDto";
import { ProductionWorkflowOwnersDto } from "../../../core/models/project-workflow/productionWorkflowOwnersDto";
import { ProjectFileDto } from "../../../core/models/project-workflow/projectFileDto";
import { ProjectWorkflowReAssignEmailDto } from "../../../core/models/project-workflow/projectWorkflowReAssignEmailDto";
import { UpdateWorkflowHeaderRequestDto } from "../../../core/models/project-workflow/updateWorkflowHeaderRequestDto";
import { WorkflowEmailData } from "../../../core/models/project-workflow/workflowEmailData";
import { WorkflowNotificationSettings } from "../../../core/models/project-workflow/workflownotificationSettingDto";
import { WorkflowOwnersDto } from "../../../core/models/project-workflow/workflowOwnersDto";
import { WorkflowStatusDto } from "../../../core/models/project-workflow/workflowStatusDto";
import { FileUploadDto } from "../../../core/models/shared/fileUploadDto";
import { GetAllTaskResponse } from "../../../core/models/task-management/getAllTaskResponseDto";
import { ValidateLogin } from "../../../core/models/validate-login.dto";
import { BuyerService } from "../../../core/services/buyer.service";
import { LoaderService } from "../../../core/services/loader.service";
import { ProfileFormService } from "../../../core/services/profile-form.service";
import { ProjectWorkflowService } from "../../../core/services/project-workflow.service";
import { SaleOrderService } from "../../../core/services/sale-order.service";
import {
  SharedService,
  getBase64,
} from "../../../core/services/shared.service";
import { SignalRService } from "../../../core/services/signal-r.service";
import { EnumWorkflowHeaderColorStatus } from "../../../shared/enums/enumWorkflowHeaderColorStatus";
import { ProjectWorkflowReAssignStatus } from "../../../shared/enums/projectWorkflowReAssignStatus";
import { TaskTypeEnum } from "../../../shared/enums/taskTypeEnum";
import { UserRole } from "../../../shared/enums/userRoles.enum";
import { EnumWorkflowEmailState } from "../../../shared/enums/workflowEmailState";
import { WorkflowStatusEnum } from "../../../shared/enums/workflowStatusEnum";
import { AddClientContact } from "../../../core/models/client/addClientContact";
import { ChatboxComponent } from "../../../shared/components/chatbox/chatbox.component";
import { TableModule } from "primeng/table";
import { Popover, PopoverModule } from "primeng/popover";
import { WorkflowUpdatesComponent } from "../workflow-updates/workflow-updates.component";
import { ModalStackerComponent } from "../../../shared/components/modal-stacker/modal-stacker.component";
import { WorkflowErrorLogsComponent } from "../workflow-error-logs/workflow-error-logs.component";
import { DialogModule } from "primeng/dialog";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { WorkflowEmailComponent } from "../workflow-email/workflow-email.component";
import { SpinnerComponent } from "../../../shared/components/spinner/spinner.component";
import { NotificationSettingsComponent } from "../notification-settings/notification-settings.component";
import { AddContactInformationComponent } from "../add-contact-information/add-contact-information.component";
import { ProductionWorkflowReassignLogDto } from "../../../core/models/project-workflow/productionWorkflowReassignLogDto";
import { SelectChangeEvent, SelectModule } from "primeng/select";
import { FileUploadHandlerEvent, FileUploadModule } from "primeng/fileupload";
import { MultiSelectModule } from "primeng/multiselect";
import { GetBCForSalesOrderDto } from "../../../core/models/orders/getBCForSalesOrderDto";
import { GetBacForSalesOrderDto } from "../../../core/models/orders/getBacForSalesOrderDto";
import { RenameProjectFileRequestDto } from "../../../core/models/project-workflow/renameProjectFileRequestDto";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";
import { AssignOrderToProjectDto } from "../../../core/models/orders/assignOrderToProjectDto";
import { OrderSummaryService } from "../../../core/services/order-summary.service";
import {
  GlobalFileDragDropDirective,
  DroppedFile,
} from "../../../shared/directives/global-file-drag-drop.directive";
import { GlobalFileUploadService } from "../../../shared/services/global-file-upload.service";

@UntilDestroy()
@Component({
  selector: "jni-production-workflow-summary",
  templateUrl: "./production-workflow-summary.component.html",
  styleUrls: [
    "./production-workflow-summary.component.scss",
    "../../../shared/directives/global-file-drag-drop.styles.scss",
  ],
  providers: [ConfirmationService],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TableModule,
    PopoverModule,
    WorkflowUpdatesComponent,
    ChatboxComponent,
    ModalStackerComponent,
    WorkflowErrorLogsComponent,
    DialogModule,
    ConfirmDialogModule,
    FormsModule,
    WorkflowEmailComponent,
    WorkflowLogsComponent,
    ProjectTaskListComponent,
    WorkflowLineItemsComponent,
    SpinnerComponent,
    NotificationSettingsComponent,
    AddContactInformationComponent,
    SelectModule,
    FileUploadModule,
    MultiSelectModule,
    ButtonModule,
    CardModule,
    InputTextModule,
    GlobalFileDragDropDirective,
  ],
})
export class ProductionWorkflowSummaryComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  showCloseIcon = true;
  @Input() salesOrderId = "";
  @Input() fromOrderSummary = false;
  @Input() workflowId = 0;
  @Input() quoteIdD365 = "";

  @ViewChild("chatBox", { static: false })
  chatBox!: ChatboxComponent;

  @ViewChild("reassignLogs", { static: false })
  reassignLogs!: WorkflowLogsComponent;

  @ViewChild("linesComponent", { static: false })
  linesComponent!: WorkflowLineItemsComponent;
  popupmessage = "";
  dialogStatus = false;

  @Output() scrollHiddenStatus = new EventEmitter();
  @Output() hasUnsavedChangesEvent = new EventEmitter<boolean>();
  @Output() closeModalEvent = new EventEmitter();

  @ViewChild("productionTask", { static: false })
  productionTaskListComponent!: ProjectTaskListComponent;

  @ViewChild("salesTask", { static: false })
  salesTaskListComponent!: ProjectTaskListComponent;

  showLinkOrderModal = false;
  salesorderList: string[] = [];

  constructor(
    private router: Router,
    private _fb: FormBuilder,
    private _loaderService: LoaderService,
    private _workflowService: ProjectWorkflowService,
    private _saleOrderService: SaleOrderService,
    private route: ActivatedRoute,
    private _toastr: JniToastrService,
    private _loginService: UserManagementService,
    private _profileFormService: ProfileFormService,
    private _signalRService: SignalRService,
    private _buyerService: BuyerService,
    private _sharedService: SharedService,
    public datepipe: DatePipe,
    private confirmationService: ConfirmationService,
    private _orderSummaryService: OrderSummaryService,
    private _globalFileUploadService: GlobalFileUploadService
  ) {
    this.route.params.subscribe(params => {
      this.workflowId = Number(params["id"]);
      this.salesOrderIdD365 = this.salesOrderId =
        params["salesOrderId"] === "0" ? "" : params["salesOrderId"];
      this.showCloseIcon = (params["showCloseIcon"] ?? "true") === "true";
      if (
        this.workflowId &&
        this.salesOrderIdD365 &&
        this.salesOrderId &&
        this.showCloseIcon === false
      ) {
        this.refreshData();
        //this.openChatFromNotification = true;
      } else if (
        this.workflowId &&
        this.salesOrderIdD365 &&
        this.salesOrderId
      ) {
        this.openChatFromNotification = true;
        this.refreshData();
        //this.openChatFromNotification = true;
      } else {
        this.openChatFromNotification = false;
      }
    });

    this.initializeForm();
    effect(() => {
      const messageListValue = this._signalRService.messageList();
      if (messageListValue && this.workflowId && this.workflowId !== 0) {
        //this.getWorkflowOwnersList();
        //this.signalRChatBoxShow = false;
        this.getMessagesList();
      }

      const trackingChanges = this._signalRService.trackingBarChanges();
      if (
        trackingChanges &&
        typeof trackingChanges === "object" &&
        "isAllowed" in trackingChanges &&
        trackingChanges.isAllowed
      ) {
        if (
          trackingChanges?.data?.projectId === this.workflowId &&
          trackingChanges?.data?.saleOrderId === this.salesOrderId
        ) {
          this.getTrackingLineItems();
        }
      }
    });
  }

  workflowEmailDisplayModal = false;
  loggedInUserName = "";
  messageList = [] as GetChatMessageListDto[];
  chatFirstCurrentDateIndex = 0;
  chatModuleName = "Proposed Project";
  showOwnerRemoveBtn = false;
  signalRChatBoxShow = false;
  viewSettingsModal = false;
  customerAccountNumber = "";
  isSampleWorkflow = false;
  showLineSmallLoader = false;
  openChatFromNotification = false;
  isShowAllLines = false;
  newWorkflowOwner = "";
  showProposalDialog = false;
  proposalIds: string[] = [];
  enteredQuoteId = "";
  totalRecords = 0;
  selectedProposalIds: string[] = [];
  linkedProposals: string[] = [];

  salesOrderIdD365 = "";
  isAllowedToShowJobName = false;
  displayChat = false;
  loaderStatus = true;
  brandingConsultantLists: GetBCForSalesOrderDto[] = [];
  bacList: GetBacForSalesOrderDto[] = [];
  showSmallLoader = false;
  reassingWorkflowModal = false;
  workflowLogsModal = false;
  orderNumberModal = false;
  workflowForm!: FormGroup;
  workflowReassignForm!: FormGroup;
  userPersonnelNumber!: string;
  bacUserDefaultSelectionId = "";
  workflowDetails = {} as ProductionWorkflowDetails;
  logs!: ProductionWorkflowReassignLogDto[];
  availableCoowners: GetBacForSalesOrderDto[] = [];
  orderLines = [] as ProductionWorkflowLineDto[];
  addOwnerButtonEnabled = false;
  paddedWorkflowId = "";
  workflowStatusList = [] as WorkflowStatusDto[];
  workflowStatus = 0;
  isWorkflowOwners = false;
  workflowOwnersList = [] as ProductionWorkflowOwnersDto[];

  workflowEmailData = {} as WorkflowEmailData;
  userTagList = [] as UserTagDto[];
  notificationSettings = [] as WorkflowNotificationSettings[];
  currentStep = 1;
  onHold = false;
  statusBarDisabled = false;
  isCancelled = false;
  isDelivered = false;
  public customerVendor$ = new Subject<string>();
  selectedAccountNumber = "";
  buyerName = "";
  public buyerVendor$ = new Subject<string>();
  //selectedClient: any;
  personnelNumber = "";
  coownersLists: GetBacForSalesOrderDto[] = [];
  newWorkflowOwnerDisabled = false;
  errorLogsModal = false;
  clientName = "";
  jobName = "";
  enableReassignApply = true;
  reason = "";
  availableOwners: GetBCForSalesOrderDto[] = [];
  //ownersLists: GetBCForSalesOrderDto[] = [];
  w9AttachmentUrl = "https://www.irs.gov/pub/irs-pdf/fw9.pdf";
  fileObject: FileUploadDto[] = [];
  fileUrl = "";
  projectFiles: ProjectFileDto[] = [];
  fileName = "";
  completeStep = 1;
  incompleteStep = 0;
  istrackingMissing = false;
  isCancelDisabled = false;
  isLateDelivered = false;
  isShippmentIncomplete = false;
  isDeliveryIncomplete = false;
  isDisableLink = false;
  minStep = WorkflowStatusEnum.ProjectCreated;
  maxStep = WorkflowStatusEnum.ProjectCreated;
  inProductionColor = "";
  shippedColor = "";
  deliveredColor = "";
  customerIdWorkFlowDetails = "";

  progressBarStepList: Record<number, number> = {
    9: 1,
    1: 2,
    2: 3,
    3: 4,
    12: 5,
    4: 6,
    5: 7,
    6: 8,
    7: 9,
  };

  disableTrackingExcelDownload = true;
  displayProposalSummaryModal = false;
  proposalSummaryId = "";
  isAdmin = false;
  projectHasExceptions = false;
  taskType = TaskTypeEnum;
  assignedToUserList: { personnelNumber: string; name: string }[] = [];
  salesTaskSmallLoader = false;
  salesTaskList = [] as GetAllTaskResponse[];
  productionTaskList = [] as GetAllTaskResponse[];
  orderInHandDate = "";
  customerIdD365 = "";
  productionTaskSmallLoader = false;
  showTaskGrids = true;
  renameProjectFileId = 0;
  renameProjectFileName = "";
  renameProjectFileExtension = "";
  showRenameProjectFileDailog = false;
  hasUnsavedChanges = false;
  previousData = [] as ProductionWorkflowLineDto[];
  projectFileLink = "";
  projectLinkName = "";
  projectFileLinkId = 0;
  showAddProjectFileLinkModal = false;
  projectFileLinkModalHeader = "";
  projectFileLinkMode = "";
  buyerLists: GetAllBuyersResponseDto[] = [];
  linkSelectedOrder = "";
  deliveryAddress = [
    {
      id: 1,
      name: "One Time",
      status: false,
    },
    {
      id: 2,
      name: "Bill To",
      status: false,
    },
    {
      id: 3,
      name: "Client Address Book",
      status: false,
    },
    {
      id: 4,
      name: "Multi Ship To",
      status: false,
    },
    {
      id: 5,
      name: "TBD",
      status: false,
    },
  ];

  displayAddContact = false;
  addClientContact: AddClientContact = {} as AddClientContact;
  preSelectedCoOwners = 0;

  ngOnInit(): void {
    this.getWorkflowStatusList();
    this.getUserProfile();

    if (this.salesOrderId) {
      this.workflowId = this.workflowId ? this.workflowId : 0;
    } else if (this.workflowId) {
      this.paddedWorkflowId = this.workflowId.toString().padStart(6, "0");
      this.isSampleWorkflow = true;
      this.workflowForm.patchValue({
        details: {
          workflowId: this.paddedWorkflowId,
        },
      });
    }
    this.getWorkflowSummary();
    if (this.openChatFromNotification) {
      this.showChatBox();
    }

    this.getReassignedWorkflowLogs();
    this.getSaleTaskList();
    this.getProductionTaskList();
  }

  private initializeForm() {
    this.workflowForm = this._fb.group({
      details: this._fb.group({
        workflowId: new FormControl({ value: "", disabled: true }),
        //buyerEmail: [""],
        buyerName: [""],
        owner: [""],
        jobName: [""],
        coowners: this._fb.array([
          this._fb.group({
            coowner: [""],
          }),
        ]),
      }),
    });
  }

  get owner(): FormGroup {
    return this.workflowForm.get("details.owner") as FormGroup;
  }

  get coowners(): FormArray {
    return this.workflowForm.get("details.coowners") as FormArray;
  }

  addCoOwner() {
    const items = this.coowners;
    //this.getAvailableCoOwners();
    //this.bacList = this.availableCoowners;
    if (!items.invalid) {
      items.push(
        this._fb.group({
          coowner: [""],
        })
      );
    }
    this.preSelectedCoOwners = items.controls.map(
      ctrl => ctrl.get("coowner")?.value
    ).length;
  }

  removeCoOwner(index: number) {
    if (this.coowners.length > 0) {
      const items = this.coowners;
      items.removeAt(index);
      this.preSelectedCoOwners = items.controls.map(
        ctrl => ctrl.get("coowner")?.value
      ).length;
      // const selectedCoowners = items.controls
      //   .filter(x => x.get("coowner")?.value !== "")
      //   .map(ctrl => ctrl.get("coowner")?.value);

      // if (selectedCoowners.length < this.coownersLists.length) {
      //   this.addOwnerButtonEnabled = true;
      // }
    }
  }

  updateWorkflowHeader(showToastr: boolean) {
    const owners: WorkflowOwnersDto[] = [];
    const workflowCoOwners = this.coowners;
    const owner = this.workflowForm.get("details.owner")?.value;
    if (!workflowCoOwners.invalid) {
      this.getMinMaxStatus();
      workflowCoOwners.controls.forEach(control => {
        const coowner = control.get("coowner")?.value;

        if (coowner && coowner !== "") {
          const ownersDto: WorkflowOwnersDto = {
            workflowOwner: "",
            workflowCoOwner: coowner,
            isPrimary: false,
          };
          owners.push(ownersDto);
        }
      });
    }

    if (owner && owner !== "") {
      const ownersDto: WorkflowOwnersDto = {
        workflowOwner: owner,
        workflowCoOwner: "",
        isPrimary: true,
      };
      owners.push(ownersDto);
    }

    if (
      this.orderLines.length > 0 &&
      this.workflowStatus !== WorkflowStatusEnum.Complete &&
      this.workflowStatus !== WorkflowStatusEnum.Cancelled &&
      this.workflowStatus !== WorkflowStatusEnum.ProjectCreated &&
      this.workflowStatus !== WorkflowStatusEnum.OrderWritten
    ) {
      this.workflowStatus = Number(
        Object.keys(this.progressBarStepList).find(
          key => this.progressBarStepList[Number(key)] === this.minStep
        )
      );
    } else if (
      this.salesOrderId &&
      this.orderLines.length === 0 &&
      this.workflowStatus !== WorkflowStatusEnum.Cancelled
    ) {
      this.workflowStatus = WorkflowStatusEnum.OrderWritten;
    } else if (
      !this.salesOrderId &&
      this.workflowStatus !== WorkflowStatusEnum.Cancelled
    ) {
      this.workflowStatus = WorkflowStatusEnum.ProjectCreated;
    }

    const payload: UpdateWorkflowHeaderRequestDto = {
      workflowId: this.workflowId,
      workFlowStatusId: this.workflowStatus,
      workflowOwners: owners,
      onHold: this.onHold,
      buyerName: this.buyerName,
      jobName: !this.salesOrderIdD365
        ? this.workflowForm.get("details.jobName")?.value
        : undefined,
    };

    this._loaderService.setLoaderState(true);
    this._workflowService.updateWorkflowHeaderData(payload).subscribe({
      next: res => {
        this._loaderService.setLoaderState(false);
        this.isWorkflowOwners = true;
        if (owners.length > 0) {
          this.signalRChatBoxShow = true;
        } else {
          this.signalRChatBoxShow = false;
        }
        if (showToastr) {
          if (res?.status?.toLowerCase() === "success") {
            if (
              !this.salesOrderIdD365 &&
              this.jobName !== this.workflowForm.get("details.jobName")?.value
            ) {
              this.jobName = this.workflowForm.get("details.jobName")?.value;
              this.getSaleTaskList();
            }
            this._toastr.success(
              "Success",
              res.message || "workflow submitted successfully"
            );

            if (this.workflowStatus === WorkflowStatusEnum.Complete) {
              this.isDisableLink = true;
              this.disableBuyerField();
            }
            this.onInputChange(false);
          } else {
            this._toastr.error(
              "Error",
              res.message || "Error submitting workflow"
            );
          }
        }
        this.workflowId = payload.workflowId;
        //this.getAvailableCoOwners();
      },
      error: () => {
        this._loaderService.setLoaderState(false);
      },
    });
  }

  clearFormArray = (formArray: FormArray) => {
    formArray.clear();
    formArray.reset();
  };

  getWorkflowSummary() {
    if (this.salesOrderId == null || this.salesOrderId === "0") {
      this.salesOrderId = "";
    }

    this._loaderService.setLoaderState(true);
    this._workflowService
      .getProductionWorkflowDetails(this.salesOrderId, this.workflowId)
      .subscribe({
        next: res => {
          if (res?.data && res?.status === "Success") {
            this._loaderService.setLoaderState(false);
            this.workflowId = res?.data?.workflowId;
            this.paddedWorkflowId = this.workflowId.toString().padStart(6, "0");
            this.clientName = res?.data?.customerName;
            this.jobName = res?.data?.jobNameD365;
            this.getSavedWorkflowOwnersList();
            this.isAllowedToShowJobName = true;
            this.salesOrderIdD365 = res?.data?.salesOrderIdD365 ?? "";
            // this.patchValueInWorkflowOwner(
            //   res?.data?.brandingConsultantD365 ?? ""
            // );
            // this.patchValueInWorkflowCoOwner(
            //   res?.data?.accountCoordinatorD365 ?? ""
            // );
            this.getTrackingLineItems();
            this.workflowDetails = res.data;

            this.getProjectFiles();
            if (res?.data?.customerIdD365) {
              this.getWorkflowOwners(res?.data?.customerIdD365);
              this.customerIdWorkFlowDetails = res.data.customerIdD365;
            }
            if (
              (this.workflowDetails?.workflowStatusId === null ||
                this.workflowDetails.workflowStatusId === undefined) &&
              this.workflowStatusList &&
              this.workflowStatusList?.length > 0
            ) {
              this.workflowStatus = this.workflowStatusList[0].id;
            } else {
              this.onHold = res.data?.onHold;
              if (res.data?.workflowStatusId === WorkflowStatusEnum.Complete) {
                this.workflowStatus = WorkflowStatusEnum.Complete;
                this.isDelivered = true;
                this.isDisableLink = true;
                this.isCancelDisabled = true;
              } else if (
                res.data?.workflowStatusId === WorkflowStatusEnum.Cancelled
              ) {
                this.workflowStatus = WorkflowStatusEnum.Cancelled;
                this.isCancelled = true;
                this.isDisableLink = true;
                this.owner?.disable();
              } else {
                this.workflowStatus = res.data?.workflowStatusId ?? 0;
              }

              if (
                res.data?.workflowStatusId === WorkflowStatusEnum.Shipped ||
                res.data?.workflowStatusId === WorkflowStatusEnum.Delivered
              ) {
                this.isCancelDisabled = false;
              }

              if (res.data?.workflowStatusId === WorkflowStatusEnum.Delivered) {
                this.isDelivered = true;
              }
            }
            this._loaderService.setLoaderState(false);
            this.salesOrderId = res.data?.salesOrderIdD365;
            this.selectedAccountNumber = res?.data?.customerIdD365;
            this.buyerName = res?.data?.buyerName;
            this.workflowForm.patchValue({
              details: {
                workflowId: this.paddedWorkflowId,
                // buyerEmail:
                //   !res.data?.buyerEmail || res.data?.buyerEmail === ""
                //     ? (this.buyerName ?? "")
                //     : (res.data?.buyerEmail ?? ""),

                buyerName: res.data?.buyerName ?? "",
                jobName: res?.data?.jobNameD365 ?? "",
              },
            });

            if (res?.data?.proposalIds?.length) {
              this.linkedProposals = res.data.proposalIds.map(y => y ?? "");
            }
            this.orderInHandDate = res?.data?.inHandDate ?? "";
            this.customerIdD365 = res?.data?.customerIdD365 ?? "";
            this.getAllBuyers();
          }
        },
        error: () => {
          this._loaderService.setLoaderState(false);
        },
      });
  }

  getTrackingLineItems() {
    if (this.workflowId && this.salesOrderIdD365) {
      this.completeStep = 2;
      this.showLineSmallLoader = true;
      this._workflowService
        .getWorkflowLineItems(
          this.workflowId,
          this.salesOrderIdD365,
          this.isShowAllLines
        )
        .subscribe({
          next: res => {
            this.showLineSmallLoader = false;
            if (res?.data && res?.status === "Success") {
              const trackingTotalCount: number = res?.data.reduce(
                (sum: number, el: ProductionWorkflowLineDto) =>
                  (sum += el.trackingCount ?? 0),
                0
              );
              if (trackingTotalCount > 0) {
                this.disableTrackingExcelDownload = false;
              } else {
                this.disableTrackingExcelDownload = true;
              }
              this.orderLines = res?.data.map(
                (element: ProductionWorkflowLineDto) => {
                  element.stackedDataOptions = {
                    labels: ["Status"],
                    datasets: [
                      {
                        label: "Delivered",
                        data: [element.deliveredCount],
                        backgroundColor: "#639853",
                      },
                      {
                        label: "In-Transit",
                        data: [element.inTransitCount],
                        backgroundColor: "#00a8f3",
                      },
                      {
                        label: "Shipped",
                        data: [element.shippedCount],
                        backgroundColor: "#ffcb00",
                      },
                      {
                        label: "Exception",
                        data: [element.exceptionCount],
                        backgroundColor: "#e93e3e",
                      },
                    ],
                  };
                  element.chartOptions = {
                    indexAxis: "y",
                    plugins: {
                      legend: {
                        display: false,
                      },
                    },
                    responsive: true,
                    scales: {
                      x: {
                        stacked: true,
                        display: false,
                        max: element.trackingCount,
                      },
                      y: {
                        stacked: true,
                        display: false,
                      },
                    },
                    datasets: {
                      bar: {
                        stack: true,
                      },
                    },
                  };
                  return element;
                }
              );
              if (
                this.orderLines.some(
                  x => x.lineStatus === WorkflowStatusEnum.Delivered
                )
              ) {
                this.isDelivered = true;
              } else {
                this.isDelivered = false;
              }
              this.checkProjectExceptions();
              this.getMinMaxStatus();
              if (
                this.workflowStatus !== WorkflowStatusEnum.Complete &&
                this.workflowStatus !== WorkflowStatusEnum.Cancelled
              ) {
                this.workflowStatus = Number(
                  Object.keys(this.progressBarStepList).find(
                    key =>
                      this.progressBarStepList[Number(key)] === this.maxStep
                  )
                );
              }
            } else {
              this.orderLines = [];
              this.disableTrackingExcelDownload = true;
            }
            this.previousData = JSON.parse(JSON.stringify(this.orderLines));
            this.onInputChange(false);
          },
          error: res => {
            this.showLineSmallLoader = false;
            this._toastr.error("Error", res.message);
          },
        });
    }
  }

  getMinMaxStatus() {
    if (this.orderLines.length > 0) {
      const validStatuses = this.orderLines
        .map(line => line.lineStatus)
        .filter(status => status !== null) as number[];

      if (validStatuses.length > 0) {
        const validStatusIndexes = validStatuses.map(
          status => this.progressBarStepList[status]
        ) as number[];
        this.minStep = Math.min(...validStatusIndexes);
        this.maxStep = Math.max(...validStatusIndexes);

        //these checks are for use case like there are multiple lines are all have same status, set that status to green
        if (
          this.minStep === this.maxStep &&
          validStatuses.length === this.orderLines.length
        ) {
          this.completeStep = this.minStep;
        }

        //if statuses of all lines are ahead of completed step then consider minimum step as completed step and set it to green
        if (
          this.completeStep < this.minStep &&
          validStatuses.length === this.orderLines.length
        ) {
          this.completeStep = this.minStep;
        }

        //these checks is for use case like there are multiple line items and user update status of any line to shipped or delivered
        if (
          (this.completeStep < this.minStep &&
            validStatuses.length < this.orderLines.length) ||
          this.maxStep >= 8
        ) {
          this.minStep = this.completeStep;
        }

        //this check is for use case like user set status of all lines to production then move status of all lines to previous stage.
        if (this.completeStep > this.maxStep) {
          this.completeStep = this.maxStep;
        }

        if (this.workflowStatus !== WorkflowStatusEnum.Complete) {
          this.inProductionColor = this.setStatusColor("inProductionColor");
          this.shippedColor = this.setStatusColor("shippedColor");
          this.deliveredColor = this.setStatusColor("deliveredColor");
        } else {
          this.inProductionColor = "prog-green";
          this.deliveredColor = "prog-green";
          if (this.projectHasExceptions) {
            this.shippedColor = "prog-red";
          } else {
            this.shippedColor = "prog-green";
          }
        }
      } else if (this.orderLines.every(x => x.lineStatus === null)) {
        this.maxStep =
          this.minStep =
          this.completeStep =
            this.progressBarStepList[WorkflowStatusEnum.OrderWritten];
      } else {
        this.maxStep =
          this.minStep =
          this.completeStep =
            this.progressBarStepList[this.workflowStatus];
      }
    }
  }

  setStatusColor(statusKey: keyof ProductionWorkflowLineDto) {
    const colors = this.orderLines
      .map(line => line[statusKey])
      .filter(color => color != null) as number[];
    return colors.length > 0
      ? this.getStatusColorClass(Math.max(...colors))
      : "";
  }

  getStatusColorClass(color: number) {
    switch (color) {
      case EnumWorkflowHeaderColorStatus.Green:
        return "prog-green";
      case EnumWorkflowHeaderColorStatus.Yellow:
        return "prog-yellow";
      case EnumWorkflowHeaderColorStatus.Red:
        return "prog-red";
      default:
        return "";
    }
  }

  patchOwnersDetails(data: ProductionWorkflowOwnersDto[]) {
    if (data?.length === 1) {
      this.patchValueInWorkflowOwner(data[0]?.workflowOwner);
    }
  }

  getWorkflowOwners(accountNumber: string) {
    if (accountNumber == null || accountNumber == "") return;

    this._saleOrderService
      .getBCForSalesOrder(accountNumber)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res.data != null) {
            this.brandingConsultantLists = res.data;
            this.brandingConsultantLists.forEach(
              (item: GetBCForSalesOrderDto) => {
                if (item.personnelNumber) {
                  this.getWorkflowCoOwners(item.personnelNumber);
                }
              }
            );
            //this.getAvailableOwners();
            this.assignedToUserList.push(
              ...this.brandingConsultantLists.map(x => {
                const user: { personnelNumber: string; name: string } = {
                  personnelNumber: x.personnelNumber,
                  name: x.projectName,
                };
                return user;
              })
            );
          }
        },
        error: res => {
          this._toastr.error("Error", res.message);
        },
      });
  }

  getAvailableCoOwners() {
    const selectedCoowners = this.coowners.controls
      .filter(x => x.get("coowner")?.value !== "")
      .map(ctrl => ctrl.get("coowner")?.value);

    const newOwners = this.coownersLists.filter(
      x => !selectedCoowners.includes(x.personnelNumber)
    );

    this.availableCoowners = newOwners;

    if (
      selectedCoowners.length == this.coownersLists.length &&
      this.coownersLists.length != 0
    ) {
      this.addOwnerButtonEnabled = false;
      return;
    }

    if (selectedCoowners.length < this.coownersLists.length) {
      this.addOwnerButtonEnabled = true;
    }

    if (this.availableCoowners.length < 1) {
      this.addOwnerButtonEnabled = false;
    }
  }

  getWorkflowCoOwners(personnelNumber: string) {
    if (personnelNumber == null || personnelNumber == "") return;
    this._saleOrderService
      .getBacForSalesOrder(personnelNumber)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res.data != null) {
            const incoming = res.data.map(item => ({
              ...item,
              bcValue: personnelNumber,
            }));
            const combinedList = [...this.bacList, ...incoming].filter(
              (item, index, self) =>
                index ===
                self.findIndex(t => t.personnelNumber === item.personnelNumber)
            );
            this.bacList = combinedList;
            this.coownersLists = combinedList;
            //this.getAvailableCoOwners();
            this.assignedToUserList.push(
              ...this.bacList.map(x => {
                const user: { personnelNumber: string; name: string } = {
                  personnelNumber: x.personnelNumber,
                  name: x.name,
                };
                return user;
              })
            );
          }
        },
        error: res => {
          this._toastr.error("Error", res.message);
        },
      });
  }

  getFilteredOptions(index: number): GetBacForSalesOrderDto[] {
    const selectedValues = this.coowners.controls.map(
      control => control.get("coowner")?.value
    );

    return this.bacList.filter(
      bac =>
        !selectedValues.includes(bac.personnelNumber) ||
        selectedValues.indexOf(bac.personnelNumber) === index
    );
  }

  patchValueInWorkflowOwner(data: string) {
    this.workflowForm.patchValue({
      details: {
        owner: data,
      },
    });
    this.getWorkflowCoOwners(data);
  }

  patchCoOwnerDetails(data: ProductionWorkflowOwnersDto[]) {
    if (data?.length > 1) {
      this.patchValueInWorkflowCoOwner(data[0]?.coOwner);
      const control = this.coowners;
      data?.forEach((coowner: ProductionWorkflowOwnersDto, index: number) => {
        if (index === 0) return;
        control.push(
          this._fb.group({
            coowner: [coowner.coOwner],
          })
        );
      });
    } else if (data?.length === 1) {
      this.patchValueInWorkflowCoOwner(data[0]?.coOwner);
    }
  }

  patchValueInWorkflowCoOwner(personnelNumber: string) {
    if (this.coowners.length > 0) {
      const ownerFormGroup = this.coowners.at(0) as FormGroup;
      const ownerControl = ownerFormGroup.get("coowner");
      if (ownerControl) {
        ownerControl.patchValue(personnelNumber);
      }
    }
  }

  onWorkflowOwnerSelection(event: SelectChangeEvent) {
    this.bacList = [];
    if (event != null) {
      this.getWorkflowCoOwners(event.value);
    }
    //this.getAvailableOwners();
  }

  openLogsScreen() {
    this.workflowLogsModal = true;
  }

  closeWorkflowLogsModal() {
    this.workflowLogsModal = false;
  }

  openModalOrderNumber() {
    this.orderNumberModal = true;
  }

  closeModalOrderNumber() {
    this.orderNumberModal = false;
  }

  showChatBox() {
    this.getWorkflowOwnersList();
  }

  onHide() {
    this.displayChat = false;
  }

  closeModalForWorkflowEmail() {
    this.workflowEmailDisplayModal = false;
  }

  displayWorkflowEmailModal() {
    this.workflowEmailData.saleOrderId = this.salesOrderIdD365;
    this.workflowEmailData.workflowId = this.workflowId;
    this.workflowEmailData.windowState =
      EnumWorkflowEmailState.PrintWorkflowSummary;
    this.workflowEmailDisplayModal = true;
  }

  refreshWorflowLineItems() {
    this.getTrackingLineItems();
  }

  getMessagesList() {
    // const loaderStatus = this._loaderService.status;
    // if (!loaderStatus) {
    //   this._loaderService.setLoaderState(true);
    // }
    this._workflowService
      .getChatMessageList(this.workflowId, "ProductionWorkflow")
      .subscribe({
        next: res => {
          if (res && res.status === "Success") {
            const today = new Date().toDateString();
            const index = res.data.findIndex(item => {
              const itemDate = new Date(item.createdDate);
              return itemDate.toDateString() === today;
            });
            if (index !== -1) {
              this.chatFirstCurrentDateIndex = index;
            }
            this.messageList = res.data;
          }
          if (this.signalRChatBoxShow) {
            this.displayChat = true;
          }
          this._loaderService.setLoaderState(false);
        },
        error: () => {
          this._toastr.error("Error", "Unable to get Chat Messages");
          this._loaderService.setLoaderState(false);
        },
      });
  }

  sendChatMessage(event: string) {
    this._loaderService.setLoaderState(true);
    if (!event) {
      this._toastr.error("Error", "Chat Message cannot be empty");
      this._loaderService.setLoaderState(false);
      return;
    }
    const payload = {} as SendChatMessageRequestDto;
    payload.moduleName = "ProductionWorkflow";
    payload.moduleId = this.workflowId.toString();
    payload.message = event;

    this._workflowService.sendChatMessage(payload).subscribe({
      next: res => {
        if (res && res.status === "Success") {
          this.getMessagesList();
        }
        this._loaderService.setLoaderState(false);
      },
      error: () => {
        this._loaderService.setLoaderState(false);
      },
    });
  }

  userTagListMapper(data: ProductionWorkflowOwnersDto[]) {
    const mappedList = data
      .filter(x => {
        if (x.workflowOwner || x.coOwner) {
          return true;
        }
        return false;
      })
      .map(obj => {
        const user = {} as UserTagDto;
        if (obj.workflowOwner) {
          user.name = obj.workflowOwnerName;
          user.userId = obj.workflowOwner;
          return user;
        } else {
          user.name = obj.coOwnerName;
          user.userId = obj.coOwner;
        }
        return user;
      });
    const filteredList = mappedList.filter(
      x => x.userId !== this.personnelNumber
    );
    this.userTagList.push(...filteredList);

    const mappedBacList = this.bacList
      .filter(
        obj =>
          !this.userTagList.some(
            (user: UserTagDto) => user.userId === obj.personnelNumber
          ) && obj.personnelNumber !== this.personnelNumber
      )
      .map(obj => {
        const user = {} as UserTagDto;
        user.name = obj.name.replace(/\s+/g, "");
        user.userId = obj.personnelNumber;
        return user;
      });
    this.userTagList.push(...mappedBacList);
  }

  getWorkflowOwnersList() {
    this._loaderService.setLoaderState(true);
    this._workflowService.getWorkflowOwnersList(this.workflowId).subscribe({
      next: res => {
        if (res?.data && res.data.length > 0) {
          this.userTagList = [] as UserTagDto[];
          this.signalRChatBoxShow = true;
          this.userTagListMapper(res.data);
          this.getMessagesList();
          //this._loaderService.setLoaderState(false);
        }
      },
      error: () => {
        this._toastr.error("Error", "Unable to get Workflow Owners");
        this._loaderService.setLoaderState(false);
      },
    });
  }

  getWorkflowStatusList() {
    this._loaderService.setLoaderState(true);
    this._workflowService.getWorkflowStatusList().subscribe({
      next: res => {
        if (res?.data) {
          this.workflowStatusList = res.data;

          //set status for sample workflow header
          if (this.workflowId != 0) {
            this.workflowStatus = this.workflowStatusList[0].id;
          }
        }
        this._loaderService.setLoaderState(false);
      },
      error: () => {
        this._toastr.error("Error", "Unable to get Workflow Status List");
        this._loaderService.setLoaderState(false);
      },
    });
  }

  getSavedWorkflowOwnersList() {
    this._loaderService.setLoaderState(true);
    this._workflowService.getWorkflowOwnersList(this.workflowId).subscribe({
      next: res => {
        if (res?.status === "Success" && res?.data && res?.data?.length > 0) {
          this.workflowOwnersList = res?.data;
          this.isWorkflowOwners = true;
          this.signalRChatBoxShow = true;
          const listWorkFlowOwners = res?.data?.filter(
            x => x.workflowOwner !== null && x.workflowOwner !== ""
          );
          const listCoOwners = res?.data?.filter(
            x => x.coOwner !== null && x.coOwner !== ""
          );

          if (listWorkFlowOwners?.length > 0) {
            this.patchOwnersDetails(listWorkFlowOwners);
          }

          if (listCoOwners?.length > 0) {
            this.patchCoOwnerDetails(listCoOwners);
          }

          if (
            listCoOwners?.length > 0 &&
            (this.isCancelled ||
              this.workflowStatus === WorkflowStatusEnum.Complete)
          ) {
            this.coowners?.disable();
          }

          if (
            listWorkFlowOwners?.length > 0 &&
            (this.isCancelled ||
              this.workflowStatus === WorkflowStatusEnum.Complete)
          ) {
            this.owner.disable();
          }

          if (listCoOwners.length == 0) {
            this.removeCoOwner(0);
          }

          this.preSelectedCoOwners = listCoOwners.length;
          //this.getAvailableCoOwners();
        }
        this._loaderService.setLoaderState(false);
      },
      error: () => {
        this._toastr.error("Error", "Unable to get Workflow Owners");
        this._loaderService.setLoaderState(false);
      },
    });
  }

  showOrHideNotificationSettings() {
    this.viewSettingsModal = !this.viewSettingsModal;
  }

  markAsComplete() {
    this.workflowStatus = WorkflowStatusEnum.Complete;
    this.completeStep = this.progressBarStepList[WorkflowStatusEnum.Delivered];
    this.istrackingMissing = false;
    this.updateWorkflowHeader(true);
  }

  getNotificationSettings() {
    this._loaderService.setLoaderState(true);
    this._workflowService
      .getWorkflowNotificationSettings(this.workflowId, false, 0, false)
      .subscribe({
        next: res => {
          if (res?.data) {
            this.notificationSettings = res?.data;
            this.showOrHideNotificationSettings();
            this._loaderService.setLoaderState(false);
          }
          this._loaderService.setLoaderState(false);
        },
        error: () => {
          this._toastr.error("Error", "Unable to fetch notification settings");
          this._loaderService.setLoaderState(false);
        },
      });
  }

  // onContactList(contactdropdown: any) {
  //   contactdropdown.open();
  // }

  hideNotificationSettingDailog(event: boolean) {
    this.viewSettingsModal = event;
  }

  getUserProfile() {
    this._loginService
      .validateLogin()
      .pipe()
      .subscribe((res: GenericResponseDto<ValidateLogin>) => {
        this.getUserById(res?.data?.userId);
      });
  }

  getUserById(userId: number) {
    this._profileFormService.getUsersById(userId).subscribe({
      next: res => {
        if (res?.data) {
          this.personnelNumber = res?.data.personnelNumber;
          if (res?.data.userRoleId === UserRole.Admin) {
            this.isAdmin = true;
          } else {
            this.isAdmin = false;
          }
        }
      },
    });
  }

  refreshData() {
    this.ngOnInit();
  }

  redirectToSaleorder() {
    if (this.salesOrderId) {
      const url = this.router.serializeUrl(
        this.router.createUrlTree([
          `/orders/order-summary/${this.salesOrderId}`,
        ])
      );
      window.open(url, "_blank");
    }
  }

  redirectToProposal(proposalId: string) {
    if (proposalId && proposalId !== "") {
      const url = this.router.serializeUrl(
        this.router.createUrlTree([`/proposal/quote-summary/${proposalId}`])
      );
      window.open(url, "_blank");
    }
    // const url = `/proposal/quote-summary/${proposalId}`;
    // this.router.navigate([url]);
  }

  // onKeyDown(event: any) {
  //   event.preventDefault();
  // }

  getReassignedWorkflowLogs() {
    this._loaderService.setLoaderState(true);
    this._workflowService.getReassignedWorkflowLogs(this.workflowId).subscribe({
      next: res => {
        if (res?.status === "Success" && res?.data) {
          this.logs = res.data;

          const pendingLog = this.logs.filter(
            (x: ProductionWorkflowReassignLogDto) =>
              x.requestStatus == ProjectWorkflowReAssignStatus.Pending
          );
          if (pendingLog.length > 0) {
            this.owner.disable();
            this.newWorkflowOwnerDisabled = true;
          }
        }
        this._loaderService.setLoaderState(false);
      },
      error: () => {
        this._loaderService.setLoaderState(false);
      },
    });
  }

  onDelete(lines: ProductionWorkflowLineDto[]) {
    this.showLineSmallLoader = true;
    const payload = {} as DeleteProjectWorkflowLinesDto;
    payload.workflowId = this.workflowId;
    payload.lineRecIds = lines.map(x => x.lineRecIdD365);

    this._workflowService.deleteProjectWorkflowLines(payload).subscribe({
      next: res => {
        if (res && res?.status == "Success") {
          this.linesComponent.uncheckAll();
          this.showAllLines(false);
          this.getProductionTaskList();
          this._toastr.success("Success", "Lines Deleted Successfully");
        } else {
          this._toastr.error("Error", res?.message ?? "Failed To Delete Lines");
        }
        this.showLineSmallLoader = false;
      },
      error: () => {
        this._toastr.error("Error", "Failed To Delete Lines");
        this.showLineSmallLoader = false;
      },
    });
  }

  showAllLines(showAll: boolean) {
    this.isShowAllLines = showAll;
    this.getTrackingLineItems();
  }

  openErrorLogsScreen() {
    this.errorLogsModal = true;
  }

  closeErrorLogsModal() {
    this.errorLogsModal = false;
  }

  createNewOrder() {
    this._sharedService.updateSampleWorkflow(this.workflowId);
    this.router.navigateByUrl("/orders/order-header", {
      state: {
        accountNumber: this.selectedAccountNumber,
        buyer: this.buyerName,
      },
    });
  }

  createNewProposal() {
    this._sharedService.updateSampleWorkflow(this.workflowId);
    this.router.navigateByUrl("/proposal/add-header", {
      state: {
        accountNumber: this.selectedAccountNumber,
        buyer: this.buyerName,
      },
    });
  }

  reassignWorkflowEmail() {
    if (!this.newWorkflowOwner || this.newWorkflowOwner === "") {
      this._toastr.error(
        "Error",
        "Kindly select a Owner for Reassign Workflow"
      );
      return;
    }

    if (!this.reason || this.reason === "") {
      this._toastr.error(
        "Error",
        "Kindly select a reason for Reassign Workflow"
      );
      return;
    }
    const payload: ProjectWorkflowReAssignEmailDto = {
      workflowOwner: this.owner?.value,
      newWorkflowOwner: this.newWorkflowOwner,
      reason: this.reason,
      projectWorkFlowId: this.workflowId,
      requestStatus: ProjectWorkflowReAssignStatus.Pending,
    };

    this._loaderService.setLoaderState(true);
    this._workflowService.projectWorkflowReAssignEmail(payload).subscribe({
      next: res => {
        this._loaderService.setLoaderState(false);

        if (res?.status?.toLowerCase() === "success") {
          this._toastr.success(
            "Success",
            res.message || "workflow submitted successfully"
          );
          this.owner.disable();
          this.newWorkflowOwnerDisabled = true;
          this.reassignLogs.getReassignedWorkflowLogs();
        } else {
          this._toastr.error(
            "Error",
            res.message || "Error submitting workflow"
          );
        }

        this.closeModalReassignWorkflow();
      },
      error: () => {
        this._loaderService.setLoaderState(false);
      },
    });
  }

  reassingWorkflow() {
    this.reason = "";
    this.newWorkflowOwner = "";
    this.reassingWorkflowModal = true;
  }

  closeModalReassignWorkflow() {
    this.enableReassignApply = true;
    this.reassingWorkflowModal = false;
  }

  checkSelectionReassign() {
    if (
      this.reason &&
      this.reason !== "" &&
      this.newWorkflowOwner &&
      this.newWorkflowOwner !== ""
    ) {
      this.enableReassignApply = false;
    } else {
      this.enableReassignApply = true;
    }
  }

  getAvailableOwners() {
    const selectedOwner = this.owner?.value as string;

    const newOwners = this.brandingConsultantLists.filter(x => {
      if (x.personnelNumber !== selectedOwner) {
        return true;
      } else {
        return false;
      }
    });

    if (newOwners.length > 0) {
      this.availableOwners = newOwners;
    }
  }

  getTrackingSheetExcelTemplate() {
    this._workflowService
      .getTrackingSheetExcelTemplate(this.salesOrderId, this.workflowId)
      .subscribe({
        next: res => {
          this.downloadFile(res);
        },
        error: res => {
          this._toastr.error("Error", res.message);
        },
      });
  }

  downloadFile(data: Blob) {
    const file = new Blob([data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(file, `Tracking-${this.salesOrderId}.xlsx`);
  }

  closeProposalModal() {
    this.showProposalDialog = false;
  }

  openProposalModal() {
    this.showSmallLoader = true;
    this._workflowService
      .getQuotesList()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.showProposalDialog = true;
          this.showSmallLoader = false;
          if (res && res?.data?.length > 0) {
            this.proposalIds = res.data;
          } else {
            this.proposalIds = [];
          }
        },
        error: res => {
          this._toastr.error("Error", res.message || "Data not found");
        },
      });
  }

  addWorkflowProposals() {
    const payload: AddWorkflowProposalsDto = {
      projectWorkflowId: this.workflowId,
      proposalIds: this.selectedProposalIds,
    };

    this._loaderService.setLoaderState(true);
    this._workflowService.addWorkflowProposals(payload).subscribe({
      next: res => {
        this._loaderService.setLoaderState(false);
        if (res) {
          this.linkedProposals.push(...this.selectedProposalIds);
          this.selectedProposalIds = [];
          this._toastr.success(
            "Success",
            "proposal(s) linked to project successfully"
          );
        } else {
          this._toastr.error("Error", "Error linking proposals to project");
        }
        this.showProposalDialog = false;
      },
      error: () => {
        this._loaderService.setLoaderState(false);
      },
    });
  }

  async uploadTrackingFile(target: FileUploadHandlerEvent | Event) {
    this.showSmallLoader = true;

    let fileObj: File;

    // Handle both PrimeNG FileUploadHandlerEvent and regular input events
    if ("files" in target && target.files && target.files.length > 0) {
      // PrimeNG FileUploadHandlerEvent
      fileObj = target.files[0];
    } else {
      // Regular HTML input event
      const inputElement = (target as Event).target as HTMLInputElement;
      if (!inputElement?.files || inputElement.files.length === 0) {
        this.showSmallLoader = false;
        return;
      }
      fileObj = inputElement.files[0];
    }
    const fileSize = Math.round(fileObj.size / 1024);
    const maxFileSize = 30 * 1024; //30 MB

    // file.target.value = null;

    if (!fileObj) {
      this.showSmallLoader = false;
      return;
    }

    if (fileSize > maxFileSize) {
      this._toastr.error(
        "Error",
        "File size exceeds 30MB. Please upload a smaller file."
      );
      this.showSmallLoader = false;
      return;
    }

    // Define allowed file types
    const allowedTypes = [
      ".ai",
      ".esp",
      ".ppt",
      ".pdf",
      ".jpeg",
      ".jpg",
      ".eps",
      ".pptx",
      ".xlsx",
      ".xls",
      ".docx",
      ".doc",
      ".dst",
      ".png",
    ];

    const fileExtension = "." + fileObj.name.split(".").pop()?.toLowerCase();
    const fileName = fileObj.name.split(".");
    fileName.pop();

    if (allowedTypes.includes(fileExtension)) {
      await getBase64(fileObj).then(base64Url => {
        const base64UrlString = base64Url as string;
        // Fallback to application/octet-stream if fileObj.type is empty (e.g., for DST files)
        this.createFileUploadDto(
          base64UrlString,
          fileName[0],
          fileExtension,
          fileSize,
          fileExtension === ".dst" ? "application/octet-stream" : fileObj.type
        );
        this.fileName = fileObj.name;
        this.uploadFile(this.fileObject);
      });
    } else {
      this._toastr.error(
        "Error",
        "Invalid file type. Please upload one of the following file types: AI, ESP, PPT, PDF, JPEG, EPS, PPTX, XLSX, XLS, DOCX, DOC., DST"
      );
      this.showSmallLoader = false;
    }
  }

  // Global drag and drop handlers
  onProjectFilesDropped(droppedFiles: DroppedFile[]): void {
    if (this.isDisableLink) {
      return;
    }

    // Use the global service to process files
    this._globalFileUploadService.processDroppedFiles(droppedFiles, {
      uploadMethod: files => this.handleDroppedFiles(files),
      acceptedTypes: [
        "pdf",
        "doc",
        "docx",
        "jpg",
        "jpeg",
        "png",
        "txt",
        "xlsx",
        "xls",
        "dst",
      ],
      maxFileSize: 30,
      maxFiles: 10,
      showSuccessMessage: true,
      showErrorMessage: true,
    });
  }

  onFilesRejected(rejectedFiles: { file: File; reason: string }[]): void {
    this._globalFileUploadService.handleRejectedFiles(rejectedFiles);
  }

  onDragStateChanged(): void {
    // Optional: Handle any additional UI changes during drag state
  }

  private handleDroppedFiles(droppedFiles: DroppedFile[]): void {
    // Process each dropped file using existing upload logic
    droppedFiles.forEach(droppedFile => {
      const mockEvent = {
        target: { files: [droppedFile.file] },
      } as unknown as Event;

      this.uploadTrackingFile(mockEvent);
    });
  }

  uploadFile(fileObj: FileUploadDto[]) {
    this._workflowService
      .uploadProjectFiles(fileObj)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res.status == "Success") {
            this.fileUrl = res.data;
            const projectFile: ProjectFileDto = {
              fileId: 0,
              projectWorkflowId: this.workflowId,
              fileName: this.fileName,
              fileUrl: res.data,
              isLink: false,
            };
            this.saveProjectFile(projectFile);
          }
          this.showSmallLoader = false;
        },
      });
  }

  saveProjectFile(fileObj: ProjectFileDto) {
    this._loaderService.setLoaderState(true);
    this._workflowService
      .saveProjectFile(fileObj)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.status == "Success" && res.data) {
            fileObj.fileId = res.data;
            this.projectFiles.push(fileObj);
            this._toastr.success("File uploaded successfully");
          } else {
            this._toastr.error("Error", res.message || "File already exist");
            this._loaderService.setLoaderState(false);
          }
        },
      });
  }

  getProjectFiles() {
    this._loaderService.setLoaderState(true);
    this._workflowService
      .getProjectFiles(this.workflowId)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res?.status === "Success" && res?.data) {
            this.projectFiles = res.data;
          } else {
            this.projectFiles = [];
          }
          this._loaderService.setLoaderState(false);
        },
        error: res => {
          this._toastr.error("Error", res.message);
          this._loaderService.setLoaderState(false);
        },
      });
  }

  createFileUploadDto(
    base64Url: string,
    name: string,
    extension: string,
    size: number,
    filemimetype: string
  ) {
    const base64File = base64Url.split(",")[1];
    this.fileObject = [];

    this.fileObject.push({
      base64: base64File,
      fileName: name,
      fileExtension: extension,
      fileSize: size,
      fileMimeType: filemimetype,
    });
  }

  getFileIconClass(fileName: string) {
    const extension = fileName.split(".").pop()?.toLowerCase();
    switch (extension) {
      case "ai":
        return "/assets/images/file-icons/AI-Icon.svg";
      case "esp":
      case "eps":
        return "/assets/images/file-icons/ESP-Icon.svg";
      case "ppt":
      case "pptx":
        return "/assets/images/file-icons/PPT-Icon.svg";
      case "pdf":
        return "/assets/images/file-icons/PDF-Icon.svg";
      case "jpeg":
      case "jpg":
        return "/assets/images/file-icons/JPG-Icon.svg";
      case "xlsx":
      case "xls":
        return "/assets/images/file-icons/Excel-icon.svg";
      case "docx":
      case "doc":
        return "/assets/images/file-icons/Word-icon.svg";
      case "png":
        return "/assets/images/file-icons/PNG-Icon.svg";
      default:
        return "/assets/images/file-icons/PDF-Icon.svg";
    }
  }

  isAllStatus(status: WorkflowStatusEnum): boolean {
    return (
      this.orderLines.length > 0 &&
      this.orderLines.every(line => line.lineStatus === status)
    );
  }

  isAnyStatus(status: WorkflowStatusEnum): boolean {
    return (
      this.orderLines.length > 0 &&
      this.orderLines.some(line => line.lineStatus === status)
    );
  }

  cancelProject() {
    this.isCancelled = true;
    this.workflowStatus = WorkflowStatusEnum.Cancelled;
    this.isDisableLink = true;
    this.disableBuyerField();
    this.owner?.disable();
    this.coowners?.disable();
  }

  revertCancel() {
    this.isCancelled = false;
    this.isDisableLink = false;
    this.getMinMaxStatus();
    if (this.incompleteStep !== 0) {
      this.workflowStatus = this.incompleteStep;
    } else {
      this.workflowStatus = this.completeStep;
    }

    this.owner?.enable();
    this.coowners?.enable();
    this.enableBuyerField();
  }

  postDeleteProject() {
    this._loaderService.setLoaderState(true);
    this._workflowService.postDeleteProject(this.workflowId).subscribe({
      next: res => {
        if (res?.data) {
          this._toastr.success("Success", res?.message);
        } else {
          this._toastr.error("Error", res?.message);
        }
        this._loaderService.setLoaderState(false);
      },
      error: res => {
        this._toastr.error("Error", res?.message);
        this._loaderService.setLoaderState(false);
      },
    });
  }

  isShipmentComplete() {
    if (
      this.incompleteStep ===
      this.progressBarStepList[WorkflowStatusEnum.Shipped]
    ) {
      return true;
    } else if (
      this.incompleteStep ===
        this.progressBarStepList[WorkflowStatusEnum.Delivered] &&
      this.orderLines.length > 0 &&
      this.orderLines.some(line => line.trackingCount === 0)
    ) {
      return true;
    }
    return false;
  }

  compareDates(
    date1: Date | string | null,
    date2: Date | string | null,
    operator: ">" | ">=" | "<" | "<=" | "==" | "!="
  ): boolean {
    const d1 = new Date(new Date(date1 ?? new Date()).setHours(0, 0, 0, 0));
    const d2 = new Date(new Date(date2 ?? new Date()).setHours(0, 0, 0, 0));

    switch (operator) {
      case ">":
        return d1 > d2;
      case ">=":
        return d1 >= d2;
      case "<":
        return d1 < d2;
      case "<=":
        return d1 <= d2;
      case "==":
        return d1.getTime() === d2.getTime();
      case "!=":
        return d1.getTime() !== d2.getTime();
      default:
        throw new Error(`Unsupported operator: ${operator}`);
    }
  }

  downloadProjectFile(url: string, name: string) {
    this.showSmallLoader = true;
    this._sharedService
      .getFileAsBlob(url)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.showSmallLoader = false;
          // Use fallback MIME type for unrecognized file types like DST
          const mimeType = res.type || "application/octet-stream";
          const blob = new Blob([res], { type: mimeType });

          // Create a download link to preserve the original filename and extension
          const blobUrl = URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = blobUrl;
          link.download = name; // Use the provided filename to preserve extension
          link.click();

          // Clean up
          setTimeout(() => URL.revokeObjectURL(blobUrl), 100);
        },
        error: () => {
          this._toastr.error("Error", `Unable to fetch File ${name}`);
          this.showSmallLoader = false;
        },
      });
  }

  deleteProjectFile(fileId: number) {
    this.showSmallLoader = true;
    this._workflowService
      .deleteProjectFile(fileId, this.workflowId)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res && res.status === "Success" && res.data) {
            this._toastr.success(
              "Success",
              "Successfully deleted Project File"
            );
            this.getProjectFiles();
          } else {
            this._toastr.error("Error", "Unable to delete Project File");
          }
          this.showSmallLoader = false;
        },
        error: () => {
          this.showSmallLoader = false;
          this._toastr.error("Error", "Unable to delete Project File");
        },
      });
  }

  extractFileName(url: string) {
    const urlObj = new URL(url);
    const params = new URLSearchParams(urlObj.search);
    const fileName = params.get("fileName");
    return fileName ? decodeURIComponent(fileName) : null;
  }

  deleteFileFromBlobStorage(fileId: number, fileUrl: string) {
    const fileName = this.extractFileName(fileUrl) ?? "";
    this.showSmallLoader = true;
    this._workflowService
      .deleteFileFromBlob(fileName)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res && res.status === "Success") {
            this.deleteProjectFile(fileId);
          } else {
            this._toastr.error("Error", "Unable to delete Project File");
          }
          this.showSmallLoader = false;
        },
        error: () => {
          this._toastr.error("Error", "Unable to delete Project File");
          this.showSmallLoader = false;
        },
      });
  }

  checkProjectExceptions() {
    this.projectHasExceptions = this.orderLines.some(x => x.hasExceptions);
  }

  ngOnDestroy(): void {
    this.scrollHiddenStatus.emit();
  }

  getSaleTaskList() {
    this.salesTaskSmallLoader = true;
    this._workflowService
      .getTaskListByProjectWorkflowId(this.workflowId, TaskTypeEnum.Sales)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res?.data) {
            this.salesTaskList = res.data;
          } else {
            this.salesTaskList = [];
          }
          this.salesTaskSmallLoader = false;
          this.onInputChange(false);
        },
        error: err => {
          this._toastr.error("Error", err);
          this.salesTaskSmallLoader = false;
        },
      });
  }

  getProductionTaskList() {
    this.productionTaskSmallLoader = true;
    this._workflowService
      .getTaskListByProjectWorkflowId(this.workflowId, TaskTypeEnum.Production)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res?.data) {
            this.productionTaskList = res.data;
          } else {
            this.productionTaskList = [];
          }
          this.productionTaskSmallLoader = false;
          this.onInputChange(false);
        },
        error: err => {
          this._toastr.error("Error", err);
          this.productionTaskSmallLoader = false;
        },
      });
  }

  createProductionTaskEvent(event: ProductionWorkflowLineDto) {
    if (event && this.productionTaskList) {
      this.productionTaskListComponent.cancelAllEditRow();
      this.productionTaskListComponent.addProductionTaskRowPreview(event);
    }
  }

  // refreshGrid() {
  //   this.getSaleTaskList();
  //   this.getProductionTaskList();
  // }

  renameProjectFileDailog(fileId: number, fileName: string) {
    this.showRenameProjectFileDailog = !this.showRenameProjectFileDailog;
    this.renameProjectFileId = fileId;
    const lastDotIndex = fileName.lastIndexOf(".");
    this.renameProjectFileName = fileName.substring(0, lastDotIndex);
    this.renameProjectFileExtension = fileName
      .substring(lastDotIndex + 1)
      .toLowerCase();
  }

  closeRenameProjectFileDailog() {
    this.showRenameProjectFileDailog = false;
    this.renameProjectFileId = 0;
    this.renameProjectFileName = "";
  }

  saveRenameProjectFile() {
    this.showSmallLoader = true;
    if (this.renameProjectFileName === "") {
      this._toastr.error("Error", "File Name cannot be empty");
      this.showSmallLoader = false;
      return;
    }

    const req = {
      newName:
        this.renameProjectFileName + "." + this.renameProjectFileExtension,
      projectId: this.workflowId,
      fileId: this.renameProjectFileId,
    } as RenameProjectFileRequestDto;

    this._workflowService
      .renameProjectFile(req)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.showSmallLoader = false;
          if (res?.data) {
            this.showRenameProjectFileDailog = false;
            this._toastr.success(
              "Success",
              "File hase been renamed Succesfully"
            );
            this.onInputChange(false);
            this.getProjectFiles();
          } else {
            this._toastr.success("Error", "Failed to rename File");
          }
        },
        error: () => {
          this._toastr.success("Error", "Failed to rename File");
          this.showSmallLoader = false;
        },
      });
  }

  canDeactivate(): Observable<boolean> | boolean {
    if (this.hasUnsavedChanges) {
      return new Observable<boolean>(observer => {
        this.confirmationService.confirm({
          message: "You have unsaved changes. Do you really want to leave?",
          acceptLabel: "Yes",
          rejectLabel: "No",
          accept: () => {
            this.hasUnsavedChanges = false;
            observer.next(true);
            observer.complete();
          },
          reject: () => {
            observer.next(false);
            observer.complete();
          },
        });
      });
    } else {
      return true;
    }
  }

  onInputChange(event: boolean) {
    this.hasUnsavedChanges = event;
    this.hasUnsavedChangesEvent.emit(this.hasUnsavedChanges);
  }

  ngAfterViewInit(): void {
    this.workflowForm.valueChanges.subscribe(() => {
      this.hasUnsavedChanges = true;
      this.hasUnsavedChangesEvent.emit(true);
    });
  }

  openProjectFileLinkDailog(
    mode: string,
    file: ProjectFileDto = {} as ProjectFileDto
  ) {
    this.projectFileLinkModalHeader = mode + " File Link";
    this.showAddProjectFileLinkModal = true;
    this.projectFileLinkMode = mode;
    if (mode === "Edit") {
      this.projectFileLink = file.fileUrl;
      this.projectLinkName = file.fileName;
      this.projectFileLinkId = file.fileId;
    } else {
      this.projectFileLink = "";
      this.projectLinkName = "";
      this.projectFileLinkId = 0;
    }
  }

  addProjectFileLink() {
    const urlRegex = /^(https?:\/\/[^\s]+|www\.[^\s]+)$/i;
    if (this.projectFileLink === "" || this.projectLinkName === "") {
      this._toastr.error("Error", "Project File Link or Name cannot be empty");
      return;
    }

    if (!urlRegex.test(this.projectFileLink.trim())) {
      this._toastr.error(
        "Error",
        "Project File Link should only contain link in text"
      );
      return;
    }

    const payload: ProjectFileDto = {
      fileId: 0,
      projectWorkflowId: this.workflowId,
      fileName: this.projectLinkName.trim(),
      fileUrl: this.projectFileLink.trim(),
      isLink: true,
    };

    this._loaderService.setLoaderState(true);
    this._workflowService
      .saveProjectFile(payload)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.status == "Success" && res.data) {
            payload.fileId = res.data;
            this.projectFiles.push(payload);
            this._toastr.success("File uploaded successfully");
            this.closeProjectFileLinkDailog();
          } else {
            this._toastr.error("Error", res.message || "File already exist");
            this._loaderService.setLoaderState(false);
          }
        },
      });
  }

  closeProjectFileLinkDailog() {
    this.showAddProjectFileLinkModal = false;
    this.projectFileLink = "";
    this.projectLinkName = "";
  }

  editProjectFileLink() {
    if (this.projectFileLink === "" || this.projectLinkName === "") {
      this._toastr.error("Error", "Project File Link or Name cannot be empty");
      return;
    }

    const projectFile = this.projectFiles.find(
      x => x.fileId == this.projectFileLinkId
    );

    const urlRegex = /^(https?:\/\/[^\s]+|www\.[^\s]+)$/i;
    if (!urlRegex.test(this.projectFileLink.trim())) {
      this._toastr.error(
        "Error",
        "Project File Link should only contain link in text"
      );
      return;
    }

    if (!projectFile) {
      this._toastr.error("Error", "No File Found for Update");
      return;
    }

    projectFile.fileName = this.projectLinkName;
    projectFile.fileUrl = this.projectFileLink;

    this._loaderService.setLoaderState(true);
    this._workflowService
      .editProjectFileLink(projectFile)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this._loaderService.setLoaderState(false);
          if (res.status == "Success" && res.data) {
            this._toastr.success("File Link updated successfully");
            this.onInputChange(false);
            this.closeProjectFileLinkDailog();
          } else {
            this._toastr.error(
              "Error",
              res.message || "File Link update Failed"
            );
            this._loaderService.setLoaderState(false);
          }
        },
      });
  }

  searchBuyerName() {
    this.buyerVendor$
      .pipe(
        debounceTime(500),
        distinctUntilChanged(),
        switchMap((searchitem: string) => {
          if (searchitem) {
            this.showSmallLoader = true;
          }

          const request = {
            clientAccountNumber: this.customerIdD365 || "",
            buyer: searchitem,
          } as GetAllBuyersRequestDto;

          this.buyerLists = [];
          if (searchitem) {
            return this._buyerService.getAllBuyers(request);
          }
          return EMPTY;
        })
      )
      .subscribe({
        next: res => {
          if (res.data != null) {
            this.buyerLists = res.data;
          }
          this.showSmallLoader = false;
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }

  onBuyerListClick(
    buyerDropdown: Popover,
    event: Event,
    mydropBuyer: HTMLElement
  ) {
    buyerDropdown.show(event, mydropBuyer);
  }

  onBuyerSearchOpenToggle(
    mydrop: Popover,
    event: KeyboardEvent,
    mydropBuyer: HTMLElement
  ) {
    mydrop.show(event, mydropBuyer);
    const target = event.target as HTMLInputElement;
    if (target?.value != "") {
      this.deliveryAddress[1].status = false;
      this.deliveryAddress[2].status = false;
    } else {
      this.deliveryAddress[1].status = true;
      this.deliveryAddress[2].status = true;
    }
  }

  getBuyer(event: Event, mydrop: Popover) {
    this.showSmallLoader = true;
    const target = event.target as HTMLInputElement;
    const eventKey = event as KeyboardEvent;
    if (eventKey.key.toLowerCase() == "tab") {
      const payload = target?.value;
      const request: GetAllBuyersRequestDto = {
        clientAccountNumber: this.customerIdD365 || "",
        buyer: payload,
      };
      this._buyerService
        .getAllBuyers(request)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this.buyerLists = res.data;
            if (this.buyerLists.length > 0) {
              this.onBuyerSelection(this.buyerLists[0], mydrop);
            }
            this.showSmallLoader = false;
          },
          error: () => {
            this.showSmallLoader = false;
          },
        });
    }
  }

  onBuyerSelection(
    event: GetAllBuyersResponseDto,
    buyerProspetToggle: Popover
  ) {
    this.onInputChange(true);
    this.buyerName = event.buyer;
    this.workflowForm.patchValue({
      details: {
        // buyerEmail:
        //   event.buyerEmail && event.buyerEmail !== ""
        //     ? (event.buyerEmail ?? "")
        //     : (this.buyerName ?? ""),

        buyerName: event.buyer ?? "",
      },
    });
    buyerProspetToggle.hide();
  }

  getAllBuyers() {
    const request = {
      clientAccountNumber: this.customerIdD365 || "",
      buyer: "",
    } as GetAllBuyersRequestDto;
    this._buyerService
      .getAllBuyers(request)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.showSmallLoader = false;
          this.buyerLists = res.data;
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }

  disableBuyerField() {
    //this.workflowForm.get(["details", "buyerName"])?.disable();
    this.workflowForm.get(["details", "buyerName"])?.disable();
  }

  enableBuyerField() {
    //this.workflowForm.get(["details", "buyerEmail"])?.enable();
    this.workflowForm.get(["details", "buyerName"])?.enable();
  }

  addContactInformation() {
    this.addClientContact.firstName = "";
    this.addClientContact.lastName = "";
    this.addClientContact.type = "Buyer";
    this.displayAddContact = true;
  }

  isContactAdded(obj: boolean) {
    if (obj) {
      this.getAllBuyers();

      this.productionTaskListComponent?.refreshBuyerGridList();
      this.salesTaskListComponent?.refreshBuyerGridList();
    }
  }

  populateContactAddedInfo(buyer: string) {
    if (buyer) {
      this.buyerName = buyer;
      // this.parent.patchValue({
      //   orderHeader: {
      //     buyer: obj
      //   }
      // });
    }
  }

  onCloseModalEvent() {
    this.closeModalEvent.emit();
  }

  triggerContactDialog(event: string) {
    if (event !== "") {
      this.displayAddContact = true;
      this.addClientContact.type = "Buyer";
    }
  }

  getBACName(personnelNumber: string) {
    const bac = this.brandingConsultantLists?.find(
      (x: GetBCForSalesOrderDto) => x.personnelNumber === personnelNumber
    );
    return bac ? bac.projectName : "";
  }

  getGroupedFilteredOptions(i: number) {
    const options = this.getFilteredOptions(i);
    const groups: Record<string, GetBacForSalesOrderDto[]> = {};
    options.forEach(option => {
      const label = this.getBACName(option.bcValue ?? "");
      if (!groups[label]) {
        groups[label] = [];
      }
      groups[label].push(option);
    });
    return Object.keys(groups).map(label => ({
      label,
      items: groups[label],
    }));
  }

  displayLinkOrderModal() {
    this._workflowService
      .getAllSalesOrdersListWithNoProjects(this.customerIdWorkFlowDetails)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.showSmallLoader = false;
          this.salesorderList = res.data;
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
    this.showLinkOrderModal = true;
  }

  closeLinkOrderModal() {
    this.showLinkOrderModal = false;
  }

  applyTheOrderOnProject() {
    this._loaderService.setLoaderState(true);
    const payload: AssignOrderToProjectDto = {
      salesOrderIdD365: this.linkSelectedOrder,
      projectWorkflowId: Number(this.workflowId),
    };
    this._orderSummaryService
      .postAssignedProjectToSalesOrder(payload)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.closeLinkOrderModal();
          this._loaderService.setLoaderState(false);
          if (res.data) {
            this._toastr.success(
              "Success",
              "Project Assigned to Sales Order Successfully"
            );
            this.salesOrderId = this.linkSelectedOrder;
            this.getWorkflowSummary();
          } else {
            this._toastr.error(
              "Error",
              "Failed to assign project to Sales Order"
            );
          }
        },
        error: () => {
          this._loaderService.setLoaderState(false);
          this._toastr.error(
            "Error",
            "Failed to assign project to Sales Order"
          );
        },
      });
  }
}
